import { combineEpics } from "redux-observable";
import { push } from "connected-react-router";
import { of } from "rxjs";
import { ajax } from "rxjs/ajax";
import { ofType } from "redux-observable";
import { mergeMap, catchError } from "rxjs/operators";
import { authHeaders, getOrganisationBaseUrl } from "frame";
import {
	timesheetAdminActionTypes,
	onAddTimesheetSaveFailed,
	onAddTimesheetSaveSuccess,
} from "./timesheet-admin-actions";
import { LIST_TIMESHEETS_ROUTE } from "./timesheet-routes";
import moment from "moment";
import { GENERIC_ERROR_MESSAGE } from "utils";

const addTimesheetEffect = (action$, state$) =>
	action$.pipe(
		ofType(timesheetAdminActionTypes.ADD_ADMIN_TIMESHEET_FORM_SUBMIT),
		mergeMap(() => {
			const timesheetId = state$.value.timesheetAdminFormReducer.timesheet.id;
			const isActiveTimesheet = state$.value.timesheetAdminFormReducer.timesheet.toggle;
			const hasEndTime = state$.value.timesheetAdminFormReducer.timesheet.endDate && 
			                   state$.value.timesheetAdminFormReducer.timesheet.endTime;
			
			// If we have a timesheet ID and it was active (review mode - stopping a timesheet),
			// use the admin stop endpoint (similar to how users use the regular stop endpoint)
			// This ensures IsActive is set to false, just like the user stop endpoint
			if (timesheetId && isActiveTimesheet && hasEndTime) {
				const stopPayload = {
					siteId: state$.value.timesheetAdminFormReducer.siteId,
					endDateTimeUTC: moment(
						state$.value.timesheetAdminFormReducer.timesheet
							.endDate +
							" " +
							state$.value.timesheetAdminFormReducer.timesheet
								.endTime,
						"YYYY-MM-DD HH:mm"
					).toISOString(),
					lunchTimeMinutes: parseInt(
						state$.value.timesheetAdminFormReducer.timesheet
							.lunchTime,
						10
					),
					notes: state$.value.timesheetAdminFormReducer.timesheet
						.notes,
					endLatitude:
						state$.value.timesheetAdminFormReducer.timesheet
							.endLatitude,
					endLongitude:
						state$.value.timesheetAdminFormReducer.timesheet
							.endLongitude,
				organisationTaskTypeId:
					state$.value.timesheetAdminFormReducer.timesheet
						.organisationTaskTypeId || null,
			equipment:
				state$.value.timesheetAdminFormReducer.equipment ||
				state$.value.timesheetAdminFormReducer.timesheet.equipment || []
			};

				return ajax
					.post(
						`${getOrganisationBaseUrl(state$.value)}/timesheet/admin/stop/${timesheetId}`,
						stopPayload,
						authHeaders()
					)
					.pipe(
						mergeMap((ajaxResponse) => {
							return of(
								onAddTimesheetSaveSuccess(),
								push(LIST_TIMESHEETS_ROUTE)
							);
						}),
						catchError((error) =>
							of(onAddTimesheetSaveFailed(GENERIC_ERROR_MESSAGE))
						)
					);
			}

			// Otherwise, use create or update as before
		const organisationTaskTypeId =
			state$.value.timesheetAdminFormReducer.organisationTaskTypeId ||
			state$.value.timesheetAdminFormReducer.timesheet.organisationTaskTypeId ||
			null;
	const equipment =
		state$.value.timesheetAdminFormReducer.equipment ||
		state$.value.timesheetAdminFormReducer.timesheet.equipment ||
		[];

			const payload = {
				siteId: state$.value.timesheetAdminFormReducer.siteId,
				staffId:
					state$.value.timesheetAdminFormReducer.timesheet
						.staffId,
				startDateTimeUTC: moment(
					state$.value.timesheetAdminFormReducer.timesheet
						.startDate +
						" " +
						state$.value.timesheetAdminFormReducer.timesheet
							.startTime,
					"YYYY-MM-DD HH:mm"
				).toISOString(),
				endDateTimeUTC: moment(
					state$.value.timesheetAdminFormReducer.timesheet
						.endDate +
						" " +
						state$.value.timesheetAdminFormReducer.timesheet
							.endTime,
					"YYYY-MM-DD HH:mm"
				).toISOString(),
				lunchTimeMinutes: parseInt(
					state$.value.timesheetAdminFormReducer.timesheet
						.lunchTime,
					10
				),
				notes: state$.value.timesheetAdminFormReducer.timesheet
					.notes,
				startLatitude:
					state$.value.timesheetAdminFormReducer.timesheet
						.startLatitude,
				startLongitude:
					state$.value.timesheetAdminFormReducer.timesheet
						.startLongitude,
				endLatitude:
					state$.value.timesheetAdminFormReducer.timesheet
						.endLatitude,
				endLongitude:
					state$.value.timesheetAdminFormReducer.timesheet
						.endLongitude,
			organisationTaskTypeId,
			equipment
			};

			// If timesheet has an ID, update it instead of creating a new one
			const url = timesheetId 
				? `${getOrganisationBaseUrl(state$.value)}/timesheet/update/${timesheetId}`
				: `${getOrganisationBaseUrl(state$.value)}/timesheet/create`;
			
			// Add Id to payload for update
			if (timesheetId) {
				payload.Id = timesheetId;
			}

			return ajax
				.post(url, payload, authHeaders())
				.pipe(
					mergeMap((ajaxResponse) => {
						return of(
							onAddTimesheetSaveSuccess(),
							push(LIST_TIMESHEETS_ROUTE)
						);
					}),
					catchError((error) =>
						of(onAddTimesheetSaveFailed(GENERIC_ERROR_MESSAGE))
					)
				);
		})
	);

export const timesheetAdminEffects = combineEpics(addTimesheetEffect);
